'use client';

import { Tab, Tabs } from '@nextui-org/react';
import { useRouter, useSearchParams } from 'next/navigation';
import React, { useEffect, useState } from 'react';

import ClientOnly from '@/components/client-only';
import ContentSkeleton from '@/contents/user-profile/content/Skeleton';
import type { CollectionData } from '@/types/collection';

import CollectionActivity from './Activity';
import InfoCollection from './Info';
import ListAssetCollection from './List';

export enum KeyTabCollection {
  Item = 'item',
  Activity = 'activity',
}

const CollectionDetail: React.FC<{
  collection: CollectionData;
}> = ({ collection }) => {
  const searchParam = useSearchParams();
  const router = useRouter();
  const [keySelected, setKeySelected] = useState(searchParam?.get('tab') || KeyTabCollection.Item);

  useEffect(() => {
    router.replace(`/collection/${collection.id}?tab=${keySelected}`, { scroll: false });
  }, [keySelected]);

  const LIST_TAB = [
    {
      key: KeyTabCollection.Item,
      title: 'Items',
      component: <ListAssetCollection collection={collection} />,
      mustOwner: false,
    },
    {
      key: KeyTabCollection.Activity,
      title: 'Activity',
      component: <CollectionActivity />,
      mustOwner: false,
    },
  ];

  return (
    <div className="">
      <InfoCollection collection={collection} />
      <div className="main-container">
        <div className="relative mt-6 pb-10">
          <ClientOnly skeleton={<ContentSkeleton />}>
            <>
              <div className="absolute left-0 top-[33px] w-full border-b border-gray-100" />
              <Tabs
                selectedKey={keySelected}
                variant="underlined"
                onSelectionChange={(key) => setKeySelected(key as string)}
                classNames={{
                  tabList: 'gap-6 w-full relative rounded-none p-0',
                  base: 'sm:w-full overflow-x-[auto]',
                  tab: 'p-0 pb-2',
                  cursor: 'w-full bg-[#DA613A] h-[4px]',
                  tabContent: 'group-data-[selected=true]:text-[#181818] text-[#777e90] font-[600]',
                }}
              >
                {LIST_TAB.map((tab) => (
                  <Tab key={tab.key} title={tab.title}>
                    <div>{tab.component}</div>
                  </Tab>
                ))}
              </Tabs>
            </>
          </ClientOnly>
        </div>
      </div>
    </div>
  );
};

export default CollectionDetail;
